import { chakra } from '@chakra-ui/react';

const SVGIcon = ({ ...props }) => (
  <svg width={4} height={18} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={2} cy={2} r={2} fill="#fff" />
    <circle cx={2} cy={9} r={2} fill="#fff" />
    <circle cx={2} cy={16} r={2} fill="#fff" />
  </svg>
);

const ContextMenu = chakra(SVGIcon);
export default ContextMenu;
